<script setup lang="ts">
import { defineAsyncComponent, watchEffect } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useRuntimeConfig } from '#app'
import { useSeoMeta, useHead } from '#imports'
import { usePageByDevice } from '~/composables/common/use-page-by-device'
import { useMetaData } from '~/composables/news/use-meta-data'
import { useJackPot } from '~/composables/common/use-jackpot'
import { SLUG_NEWS } from '~/constants'
import { SLUG_CATEGORY_NEWS } from '~/resources/news'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const { isLighthouseBot } = useLighthouse()

const { layout } = usePageByDevice()
const config = useRuntimeConfig()
const route = useRoute()
const { title, description } = useMetaData()
const { getGameJackpotsList } = useJackPot()
const MiniGame = defineAsyncComponent(async () => await import('~/components/common/mini-game.vue'))

if (!isLighthouseBot) {
  useAsyncData('jackpots-list', async () => {
    await getGameJackpotsList()
    return { loaded: true }
  })
}

const specificCanonicals = {
  [`/${SLUG_NEWS.PAGE}?cat=${SLUG_CATEGORY_NEWS.ALL}`]: `${config.public.SITE_DOMAIN}${SLUG_NEWS.PAGE}`
}

const currentUrl = computed(() => `${config.public.SITE_DOMAIN}${route.fullPath.replace(/^\/+/, '')}`)

const canonicalLink = computed(() => ({ rel: 'canonical', href: specificCanonicals[route.fullPath] ?? currentUrl }))

// Check Maintenance
if (config.public.MAINTENANCE_TIME) {
  useRouter().push('/maintenance')
}

watchEffect(() => {
  if (title.value || description.value) {
    useSeoMeta({
      title,
      ogTitle: title,
      description,
      ogDescription: description,
      ogUrl: currentUrl.value,
      twitterCard: 'summary_large_image',
      twitterDescription: description,
      twitterTitle: title
    })
  }
})
useHead({ link: [canonicalLink] })
</script>
<template>
  <div>
    <NuxtLayout :name="layout">
      <NuxtLoadingIndicator v-if="!isLighthouseBot" />
      <NuxtPage />
    </NuxtLayout>
    <MiniGame v-if="!isLighthouseBot" />
  </div>
</template>
